// Port of api/fuel/app/classes/filter/search/games/rules/query/language_votes.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'language_votes',
	field: function() { return 'g.game_language_count' }
})
